import { render, staticRenderFns } from "./CardsDinamic.vue?vue&type=template&id=6f475825&scoped=true"
import script from "./CardsDinamic.vue?vue&type=script&lang=js"
export * from "./CardsDinamic.vue?vue&type=script&lang=js"
import style0 from "./CardsDinamic.vue?vue&type=style&index=0&id=6f475825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f475825",
  null
  
)

export default component.exports